/* global $:true dataLayer:true */
/**
 * Express Job Widget Block
 *
 *
 */

import debug from "debug";
import plugin from '../../lib/plugin';

const ELEMENT_SELECTOR = '#expr3ss-jobs-widget';
const MODULE_NAME = 'app.core/modules/express-job-widget-block';
const log = debug(MODULE_NAME);
const ZERO = 0;
const SCRIPT = '<script src="https://developers.expr3ss.com/Files/js/widget.min.js" defer="true"></script>';

class ExpressJobWidgetBlock {

    constructor (element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.$scriptContainer = $(this.options.scriptContainer);

        log('ExpressJobWidgetBlock', element);

        this.loadScript();

        log('ready', this.$element);
    }

    loadScript () {
        if (typeof(this.$scriptContainer) !== 'undefined') {
            if (this.$scriptContainer.find('script').length == 0) {
                this.$scriptContainer.html(SCRIPT);
            }
        }
    }
}

ExpressJobWidgetBlock.DEFAULTS = {
    scriptContainer: '.express-job-widget-block-scripts'
};

plugin('expressJobWidgetBlock', ExpressJobWidgetBlock);

export function exec () {
    $(document).ready(() => {
        log('binding');
        $(ELEMENT_SELECTOR).expressJobWidgetBlock();
        log('bound');
    });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/express-job-widget-block/index.js